/**
 * AgentSearchOptions
 * 
 * @Author: Focci
 * @Date: 2023-08-29 08:47:00
 * @Last Modified by: Focci
 * @Last Modified time: 2023-08-29 08:47:00
 */

'use client'

import PropTypes from 'prop-types'
import useFetch from '@hook/useFetch'
import SVGLogo from '@img/logo.svg'
import clsx from 'clsx'
import agentFace from '@img/agent-face.jpg'
import { isArray } from 'lodash-es'
import { useEffect, useMemo, useState } from 'react'
import { isWindow } from '@lib/utils'
import { getSearchOptions } from './lib'
import OptionsBody from './OptionsBody'
import SubmitSearchParam from './SubmitSearchParam'

function AgentSearchOptionsLayer({
  children,
  className = '',
}) {
  return (
    <div className={clsx(['fixed inset-0 z-10 bg-white flex', className])}>
      {children}
    </div>
  )
}

function AgentSearchOptionsScoff({ children }) {
  return (
    <AgentSearchOptionsLayer>
      <div
        className="w-1/3 bg-cover bg-norepeat bg-center hidden md:block" 
        style={{ backgroundImage: `url(${agentFace.src})` }}
      />
      <div className="overflow-y-auto w-full md:w-2/3">
        <div className="p-4 md:p-8 lg:p-16 flex flex-col max-w-[40rem] h-full">
          <SVGLogo className="text-primary shrink-0 invisible md:visible" />
          {children}
        </div>
      </div>
    </AgentSearchOptionsLayer>
  )
}

export default function AgentSearchOptions({
  suburbId,
  suburbName,
  onSubmit = () => {}
}) {
  const { data, isLoading } = useFetch(`agent/find-agent-questions/${suburbId}`)
  const [params, setParams] = useState()
  const options = useMemo(() => getSearchOptions(data), [data])
  const startField = useMemo(() => (isArray(data) ? data[0]?.field : ''), [data])

  useEffect(() => {
    isWindow && (document.documentElement.style.overflowY = 'hidden')
    return () => {
      document.documentElement.style.overflowY = 'auto'
    }
  }, [])
  
  if(params) {
    return (
      <AgentSearchOptionsLayer 
        className="justify-center items-center overflow-y-auto"
      >
        <SubmitSearchParam 
          params={params} 
          suburbName={suburbName} 
          suburbId={suburbId} 
          onSubmit={onSubmit}
        />
      </AgentSearchOptionsLayer>
    )
  }

  return (
    <AgentSearchOptionsScoff className="animate-fade-in">
      <OptionsBody
        startField={startField}
        options={options} 
        isLoading={isLoading}
        onSubmit={(v) => setParams(v)}
      />
    </AgentSearchOptionsScoff>
  )
}

AgentSearchOptions.propTypes = {
  suburbId: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
}
